/* eslint-disable react/jsx-pascal-case */
import { message, Button, Col, ConfigProvider, Form, Tag, Row, Select, Space, Table, Modal, Popconfirm, Card } from "antd";
import dayjs from 'dayjs';
import React, { useContext, useEffect, useRef, lazy, Suspense, useState } from "react";
import { default as ProTableOT } from "../../utility/ProTable_ot";
import { useNews } from "../controller/NewsController";
import { useNewsType } from "../controller/NewsTypeController";
import NewsModal from "./NewsModal";
import styled from "styled-components";
const ColorfulAntdProTable = styled.div`
    .ant-card {
        background-color: transparent !important;
    }
    .ant-pro-card {
        background-color: transparent !important;
    }
`;

const { ConfigContext } = ConfigProvider
const setParamsFilter = (obj) => {
    //拿掉值為空或是null 的東西
    return Object.entries(obj).reduce((all, [key, value]) => value === "" ? { ...all } : { ...all, [key]: value }, {})
}
const NewsOnlyRead = ({
    blogId,
    newsIdArr,
    defaultSize = 20,
    propsShowColumns = ["news_title", 'news_id'],
    type = "default",
    onGoToClick = () => { }
}) => {
    const [showColumns, setShowColumns] = useState(propsShowColumns ? propsShowColumns : ["news_title", 'news_id'])
    // const [showColumns, setShowColumns] = useState(propsShowColumns ?propsShowColumns:["news_title","name","news_time"])
    const [selectNewsTypeID, setSelectNewsTypeID] = useState(null)
    const [selectNewsTypeBackgroundColor, setSelectNewsTypeBackgroundColor] = useState("#fff")
    const columns = [
        {
            title: '發佈日期',
            key: "news_time",
            dataIndex: 'news_time',
            width: "8rem"
        },
        {
            title: '類別',
            key: "news_type_name",
            dataIndex: 'news_type_name',
            width: "5rem"

        },
        {
            title: '標題',
            dataIndex: 'news_title',
            key: 'news_title',
            render: (text, record, index) => {
                if (showColumns.includes("news_id")) {
                    return text
                }
                else {
                    return <Button

                        type="link"
                        // style={{
                        //     color: "#fff",
                        //     backgroundColor: "#A6A6A6"
                        // }}
                        onClick={() => {
                            window.open('/officialweb/news/new/'+record.news_id)
                            onGoToClick(record)
                        }}
                    >
                        {text}
                    </Button>
                }

            }
        },

        // {
        //     title: '公開狀態',
        //     key: "news_time",
        //     dataIndex: 'news_time',
        //     disabled: true,
        //     render: (text, record, index) => {
        //         let currentTime = dayjs()
        //         let news_time = dayjs(text, "YYYY-MM-DD HH:mm:ss")
        //         let isAnnounce = news_time.isBefore(currentTime)
        //         if (isAnnounce) {
        //             return <Tag color="green">
        //                 已發佈
        //             </Tag>
        //         }
        //         else {
        //             return <Tag color="red">
        //                 未發佈
        //             </Tag>
        //         }

        //     }
        // },
        // {
        //     title: '發佈時間',
        //     key: "news_time",
        //     dataIndex: 'news_time',

        // },
        // {
        //     title: '發佈者',
        //     dataIndex: 'name',
        //     key: 'name',
        // },
        // {
        //     title: '點擊率',
        //     dataIndex: 'click_num',
        //     key: 'click_num',
        // },
        {
            title: '消息連結',
            dataIndex: 'news_id',
            key: 'news_id',
            disabled: true,
            sorter: false,
            width: "30%",
            render: (text, record, index) => {
                return <Button
                    type="primary"
                    style={{
                        color: "#fff",
                        backgroundColor: "#A6A6A6"
                    }}
                    onClick={() => {
                        window.open('/officialweb/news/new/'+text)
                    }}
                >
                    點我前往
                </Button>
            }
        },
        // {
        //     title: '操作',
        //     valueType: 'option',
        //     key: 'option',
        //     fixed: 'right',
        //     sorter: false,
        //     disabled: true,
        //     render: (text, record, _index) => {
        //         return (
        //             <Space wrap>
        //                 <Button
        //                     type="link"
        //                     style={{
        //                         color: '#2BC17B'
        //                     }}
        //                     onClick={() => {
        //                         handleEditRow(record)
        //                     }}
        //                 >
        //                     修改
        //                 </Button>
        //                 <Popconfirm
        //                     title="刪除客戶"
        //                     description="確定刪除勾選客戶?"
        //                     onConfirm={() => handleDeleteRow(record?.news_id)}
        //                     onCancel={() => { }}
        //                 >
        //                     <Button
        //                         type="link"
        //                         danger>
        //                         刪除
        //                     </Button>
        //                 </Popconfirm>
        //             </Space>
        //         )
        //     }
        // },
    ];
    const [extra_columns, set_extra_columns] = useState([]);
    const actionRef = useRef();
    const [pageSize, setPageSize] = useState(defaultSize ? defaultSize : 20)
    const [selectedRowKeys, setSelectedRowKeys] = useState([])
    const [selectedRowsInfo, setSelectedRowsInfo] = useState([])
    const rowSelection = {
        //不一定都是對id
        onSelectAll: (selected, selectedRows, changeRows) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                changeRows.map((value, key) => {
                    select_temp.push(value.news_id)
                    selectRow.push(value)
                })

            }
            else {
                changeRows.map((value, key) => {
                    const index = select_temp.indexOf(value.news_id);
                    select_temp.splice(index, 1);
                    selectRow.splice(index, 1);

                })
            }
            setSelectedRowKeys(select_temp)
            setSelectedRowsInfo(selectRow)
        },
        onSelect: (record, selected, selectedRows, nativeEvent) => {
            let select_temp = [...selectedRowKeys]
            let selectRow = [...selectedRowsInfo]
            if (selected) {
                select_temp.push(record.news_id)
                selectRow.push(record)
            }
            else {
                select_temp = select_temp.filter(key => key !== record.news_id)
                selectRow = selectRow.filter(row => row.news_id !== record.news_id)
            }
            setSelectedRowKeys(pre => select_temp)
            setSelectedRowsInfo(selectRow)

        },
        getCheckboxProps: (record) => ({
            // disabled: record.pass === null,
        }),
    };
    const [modalOpen, setModalOpen] = useState(false)
    const [modalLoading, setModalLoading] = useState(false)

    const [form] = Form.useForm();

    const [axiosMode, setAxiosMode] = useState("get")
    const onCleanSelected = () => {
        setSelectedRowKeys([])
        setSelectedRowsInfo([])
    }
    const handleAddRow = () => {
        setAxiosMode("post")
        setModalOpen(true)
        form.resetFields()
    }
    const handleEditRow = (record) => {
        setAxiosMode("patch")
        setModalOpen(true)
        let news_time = dayjs(record?.news_time, "YYYY-MM-DD HH:mm:ss")
        form.resetFields()
        form.setFieldsValue({
            ...record,
            news_time
        })
    }
    const handleDeleteRow = (id) => {
        let data = []
        if (id) {
            data = [{
                news_id: id
            }]
        }

        else {
            data = selectedRowsInfo.map((val) => {
                return {
                    news_id: val?.news_id
                }
            })
        }
        if (data.length > 0) {
            deleteNewsData(data)
        }
        else {
            message.info("請選擇項目")
        }
    }

    const onFormFinish = (values) => {
        if (axiosMode === "post") {
            postNewsData([values])
        }
        else if (axiosMode === "patch") {
            patchNewsData([values])
        }
    }
    const onFinish = ({ axiosMode, status, values }) => {
        if (status === "success") {
            if (axiosMode === "post") {
                message.success("新增成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "patch") {
                message.success("修改成功")
                actionRef.current.reloadAndRest();

            }
            else if (axiosMode === "delete") {
                message.success("刪除成功")
                actionRef.current.reloadAndRest();
                setSelectedRowKeys([])
                setSelectedRowsInfo([])

            }
            setModalLoading(false)
            setModalOpen(false)
        }
        else if (status === "error") {
            if (axiosMode === "post") {
                message.error("新增失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "patch") {
                message.error("修改失敗")
                actionRef.current.reloadAndRest();
            }
            else if (axiosMode === "delete") {
                message.error("刪除失敗")
                actionRef.current.reloadAndRest();
            }
            setModalLoading(false)
            setModalOpen(false)
        }
    }
    const onBefore = ({ axiosMode, status, values }) => {
        setModalLoading(true)
    }

    const {
        NewsData,
        getNewsData,
        postNewsData,
        patchNewsData,
        deleteNewsData,
    } = useNews({
        onFinish,
        onBefore,
    })
    const {
        newsTypeOption,
        getNewsTypeOption,
        postNewsTypeData,
    } = useNewsType({
        onFinish: () => { },
        onBefore: () => { }
    })
    const {
        check,
        setCheck,
        checkAll,
        setOrders,
        custom_filter_key,
    } = useTableColumnsCheck(columns)
    useEffect(() => {
        checkAll()
        let newParams ={}
        if (newsIdArr.length > 0) {
            newParams['news_id_arr'] = newsIdArr
        }
        newParams = setParamsFilter({
            ...newParams,
        });
        getNewsTypeOption(newParams)
    }, [])
    useEffect(() => {
        actionRef.current.reloadAndRest();

    }, [selectNewsTypeID])

    return <Row>
        <Col>
            <NewsModal
                axiosMode={axiosMode}
                propsOpen={modalOpen}
                propsSetOpen={setModalOpen}

                propsForm={form}

                propsLoading={modalLoading}
                propsSetLoading={setModalLoading}

                onFinish={onFormFinish}
            />
        </Col>
        {
            type === "TypeTab" && (
                <Col span={24}>
                    <Row>
                        <Col span={24}>
                            <Button
                                style={{
                                    backgroundColor: "#fff",
                                    borderRadius: "8px 8px 0 0"
                                }}
                                size='large'
                                type="text"
                                onClick={() => {
                                    setSelectNewsTypeID(null)
                                    setSelectNewsTypeBackgroundColor("#fff")
                                }}
                            >
                                全部
                            </Button>
                            {newsTypeOption.map((value) => {
                                return <Button
                                    style={{
                                        backgroundColor: value?.background_color,
                                        borderRadius: "8px 8px 0 0"
                                    }}
                                    size='large'
                                    type="text"
                                    onClick={() => {
                                        setSelectNewsTypeID(value?.news_type_id)
                                        setSelectNewsTypeBackgroundColor(value?.background_color)
                                    }}
                                >
                                    {value?.label}
                                </Button>
                            })}
                        </Col>
                        <Col span={24}>
                            <Card
                                style={{
                                    backgroundColor: selectNewsTypeBackgroundColor
                                }}
                                size={'small'}>
                                <ColorfulAntdProTable>
                                    <ProTableOT
                                        inputColor={"#FFF"}
                                        cardBordered={false}
                                        actionRef={actionRef}
                                        headerTitle={<Space>
                                            {/* <Button
                                            type='primary'
                                            onClick={() => {
                                                handleAddRow()
                                            }}
                                            style={{
                                                backgroundColor: "#FFF9C9",
                                                color: "#000"
                                            }}
                                        >
                                            + 發佈消息
                                        </Button> */}
                                        </Space>}
                                        columns={columns.filter((element) => {
                                            return showColumns.includes(element.key)
                                        })}
                                        check={check}
                                        setCheck={setCheck}
                                        rowKey={'news_id'}
                                        selections={{
                                            // onChange: (index_, data_) => set_data(data_)
                                        }}
                                        toolBarRender={() => [
                                            // <Popconfirm
                                            //     title="刪除消息"
                                            //     description="確定刪除勾選消息?"
                                            //     onConfirm={() => handleDeleteRow()}
                                            //     onCancel={() => { }}
                                            // >
                                            //     <Button
                                            //         type='primary'
                                            //         style={{
                                            //             color: "#000",
                                            //             backgroundColor: "#ffedee"
                                            //         }}

                                            //     >
                                            //         刪除消息
                                            //     </Button>
                                            // </Popconfirm>
                                        ]}
                                        extra_columns={extra_columns}
                                        set_extra_columns={set_extra_columns}
                                        manage_columns={false}
                                        request={async (params = {}, sort, filter) => {
                                            setAxiosMode("get")
                                            let newParams = {
                                                news_type_id: selectNewsTypeID
                                            };
                                            let order = setOrders(sort)

                                            newParams = {
                                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                                ...newParams,
                                                order,
                                                size: params.pageSize,
                                                cur_page: params.current,
                                                custom_filter_value: params.keyword ?? "",
                                                custom_filter_key: custom_filter_key
                                            };
                                            if (newsIdArr.length > 0) {
                                                newParams['news_id_arr'] = newsIdArr
                                            }
                                            newParams = setParamsFilter({
                                                ...newParams,
                                                news_time: dayjs().format("YYYY-MM-DD HH:mm:ss")
                                            });

                                            setPageSize(params?.pageSize ?? 20)
                                            return getNewsData(newParams)
                                        }}
                                        pageSize={pageSize}
                                        // rowSelection={{
                                        //     type: 'checkbox',
                                        //     selectedRowKeys: selectedRowKeys,
                                        //     ...rowSelection,
                                        // }}
                                        rowSelection={false}
                                        tableAlertOptionRender={() => {
                                            return (
                                                <Space size={16}>
                                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                                </Space>
                                            )
                                        }}
                                        tableAlertRender={({
                                            selectedRowKeys,
                                            selectedRows,
                                            // onCleanSelected,
                                        }) => {
                                            return (
                                                <Space size={24}>
                                                    <span>
                                                        已選擇 {selectedRowKeys.length} 項
                                                        <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                                            取消選擇
                                                        </a>
                                                    </span>
                                                </Space>
                                            );
                                        }}
                                        scroll={{
                                            x: "max-content"
                                        }}
                                    />
                                </ColorfulAntdProTable>
                            </Card>
                        </Col>
                    </Row>
                </Col>
            )
        }
        {
            type === "default" && (
                <Col span={24}>
                    <ProTableOT
                        actionRef={actionRef}
                        headerTitle={<Space>
                            {/* <Button
                            type='primary'
                            onClick={() => {
                                handleAddRow()
                            }}
                            style={{
                                backgroundColor: "#FFF9C9",
                                color: "#000"
                            }}
                        >
                            + 發佈消息
                        </Button> */}
                        </Space>}
                        columns={columns.filter((element) => {
                            return showColumns.includes(element.key)
                        })}
                        check={check}
                        setCheck={setCheck}
                        rowKey={'news_id'}
                        selections={{
                            // onChange: (index_, data_) => set_data(data_)
                        }}
                        toolBarRender={() => [
                            // <Popconfirm
                            //     title="刪除消息"
                            //     description="確定刪除勾選消息?"
                            //     onConfirm={() => handleDeleteRow()}
                            //     onCancel={() => { }}
                            // >
                            //     <Button
                            //         type='primary'
                            //         style={{
                            //             color: "#000",
                            //             backgroundColor: "#ffedee"
                            //         }}

                            //     >
                            //         刪除消息
                            //     </Button>
                            // </Popconfirm>
                        ]}
                        extra_columns={extra_columns}
                        set_extra_columns={set_extra_columns}
                        manage_columns={false}
                        request={async (params = {}, sort, filter) => {
                            setAxiosMode("get")
                            let newParams = {
                                news_type_id: selectNewsTypeID
                            };
                            let order = setOrders(sort)
                            newParams = {
                                ...params, //只有這個範例要有，其他請看你的後端要什麼資料
                                ...newParams,
                                order,
                                size: params.pageSize,
                                cur_page: params.current,
                                custom_filter_value: params.keyword ?? "",
                                custom_filter_key: custom_filter_key
                            };
                            newParams = setParamsFilter({
                                ...newParams,
                                news_time: dayjs().format("YYYY-MM-DD HH:mm:ss")
                            });
                            setPageSize(params?.pageSize ?? 20)
                            return getNewsData(newParams)
                        }}
                        pageSize={pageSize}
                        // rowSelection={{
                        //     type: 'checkbox',
                        //     selectedRowKeys: selectedRowKeys,
                        //     ...rowSelection,
                        // }}
                        rowSelection={false}
                        tableAlertOptionRender={() => {
                            return (
                                <Space size={16}>
                                    {/* <Typography.Link>匯出資料</Typography.Link> */}
                                </Space>
                            )
                        }}
                        tableAlertRender={({
                            selectedRowKeys,
                            selectedRows,
                            // onCleanSelected,
                        }) => {
                            return (
                                <Space size={24}>
                                    <span>
                                        已選擇 {selectedRowKeys.length} 項
                                        <a style={{ marginInlineStart: 8 }} onClick={onCleanSelected}>
                                            取消選擇
                                        </a>
                                    </span>
                                </Space>
                            );
                        }}
                        scroll={{
                            // x: "max-content"
                        }}

                    />
                </Col>
            )
        }

    </Row>
}


const useTableColumnsCheck = (columns) => {
    const [check, setCheck] = useState([])
    const checkAll = () => {
        setCheck((pre) => {
            return columns
                .filter((element) => !element.disabled)
                .map((val) => val.key);
        });
    }
    const setOrders = (sorter) => {
        if (sorter) {
            let newOrders = Object.keys(sorter).map((key, index) => {
                if (sorter[key] === "descend") {
                    return JSON.stringify({
                        column: key,
                        type: 'DESC'
                    })
                }
                else {
                    return JSON.stringify({
                        column: key,
                        type: 'ASC'
                    })
                }

            })
            return newOrders
        }
        else {
            return []
        }
    }
    return {
        check,
        custom_filter_key: check,
        setCheck,
        checkAll,
        setOrders
    }
}
export default NewsOnlyRead;
